import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=a2abebfa&scoped=true"
import script from "./plans.vue?vue&type=script&lang=js"
export * from "./plans.vue?vue&type=script&lang=js"
import style0 from "./plans.vue?vue&type=style&index=0&id=a2abebfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2abebfa",
  null
  
)

export default component.exports